import { useStatStyles } from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";

const ProjectData = () => {
  return <Outlet />;
};

export default ProjectData;
